// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.summonersarena",
    name: "SA ASSISTANT",
    homepage: "https://summonersarena.io/",
    image_id: "7954b508-9ff0-4416-9aba-16209b571000",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.onechain.saas&hl=en-VN",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "saas://success",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map